import { z } from 'zod';
import { OrgIdSchema } from './common.js';

export const OrganizationSchema = z.object({
  id: OrgIdSchema,
  navn: z.string().min(1, 'Organisasjonsnavn kan ikke være tomt'),
  /** Norsk organisasjonsnummer (9 siffer) – valgfritt */
  orgNumber: z
    .string()
    .regex(/^\d{9}$/, 'Organisasjonsnummer må være 9 siffer')
    .optional(),
  /** E-postdomener knyttet til organisasjonen, f.eks. ["example.com"] */
  domains: z.array(z.string().min(1)),
  aliases: z.array(z.string()),
});

export type Organization = z.infer<typeof OrganizationSchema>;
